import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import PortalProtectedRoute from './components/PortalProtectedRoute';
import AppShell from './components/AppShell';
import PortalShell from './components/PortalShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import ClientFormPage from './pages/ClientFormPage';
import ClientDetailPage from './pages/ClientDetailPage';
import ContractsPage from './pages/ContractsPage';
import ContractFormPage from './pages/ContractFormPage';
import ContractDetailPage from './pages/ContractDetailPage';
import TemplatesPage from './pages/TemplatesPage';
import TemplateEditorPage from './pages/TemplateEditorPage';
import SigningPage from './pages/SigningPage';
import InvoicesPage from './pages/InvoicesPage';
import InvoiceFormPage from './pages/InvoiceFormPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import SettingsPage from './pages/SettingsPage';
import PortalLoginPage from './pages/PortalLoginPage';
import PortalVerifyPage from './pages/PortalVerifyPage';
import PortalHomePage from './pages/PortalHomePage';
import PortalContractDetailPage from './pages/PortalContractDetailPage';
import PortalInvoiceDetailPage from './pages/PortalInvoiceDetailPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── Admin routes ─────────────────────────────────────────────── */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sign/:token" element={<SigningPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AppShell />}>
            <Route path="/dashboard"                      element={<DashboardPage />} />
            <Route path="/clients"                        element={<ClientsPage />} />
            <Route path="/clients/new"                    element={<ClientFormPage />} />
            <Route path="/clients/:id"                    element={<ClientDetailPage />} />
            <Route path="/clients/:id/edit"               element={<ClientFormPage />} />
            <Route path="/contracts"                      element={<ContractsPage />} />
            <Route path="/contracts/new"                  element={<ContractFormPage />} />
            <Route path="/contracts/:id"                  element={<ContractDetailPage />} />
            <Route path="/contracts/templates"            element={<TemplatesPage />} />
            <Route path="/contracts/templates/new"        element={<TemplateEditorPage />} />
            <Route path="/contracts/templates/:id/edit"   element={<TemplateEditorPage />} />
            <Route path="/invoices"                       element={<InvoicesPage />} />
            <Route path="/invoices/new"                   element={<InvoiceFormPage />} />
            <Route path="/invoices/:id"                   element={<InvoiceDetailPage />} />
            <Route path="/settings"                       element={<SettingsPage />} />
          </Route>
        </Route>

        {/* ── Client portal routes ─────────────────────────────────────── */}
        <Route path="/portal/login"                element={<PortalLoginPage />} />
        <Route path="/portal/auth/verify/:token"   element={<PortalVerifyPage />} />
        <Route element={<PortalProtectedRoute />}>
          <Route element={<PortalShell />}>
            <Route path="/portal"                            element={<PortalHomePage />} />
            <Route path="/portal/contracts/:id"              element={<PortalContractDetailPage />} />
            <Route path="/portal/invoices/:id"               element={<PortalInvoiceDetailPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
